export const UPLOAD_FAILED = 'Upload Failed';
export const NETWORK_ERROR_MESSAGE = 'Make sure you have strong wireless conection and try again.';
export const RETRY_UPLOAD = 'Retry Upload';
export const UPLOADING_FILES = 'Uploading file...';
export const CANCEL_UPLOAD = 'Cancel Upload';
export const PHOTO_CAPTURE = 'PHOTO_CAPTURE';
//# sourceMappingURL=PhotoCaptureFileUploadProgressBar.js.map